module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_Lifestyle.7e4c2fe8.pdf";